import {
    buildConfigSlice,
    useConfigSlice,
    WidgetConfigSliceActionPayloadType,
} from 'widgets/store/configuration/configSlice';
import { WidgetType } from 'widgets/WidgetType';
import {
    initialPlCapsuleConfigState,
    PlCapsuleConfigState,
} from './PlCapsuleConfigState';
import { selectPlCapsuleState } from '../selectors';

export const buildPlCapsuleConfigSlice = () =>
    buildConfigSlice<PlCapsuleConfigState>(
        WidgetType.PL_CAPSULE,
        selectPlCapsuleState,
        initialPlCapsuleConfigState
    );

const {
    selectors: { selectConfigState, useConfigSelector },
    hooks: { useDispatchUpdateConfigAction },
} = buildPlCapsuleConfigSlice();

export const selectPlCapsuleConfig = selectConfigState;
export const useSelectPlCapsuleConfig = useConfigSelector;
export const useDispatchUpdatePlCapsuleConfiguration =
    useDispatchUpdateConfigAction;

export const usePlCapsuleConfigSlice = () =>
    useConfigSlice(buildPlCapsuleConfigSlice());

export type PlCapsuleConfigPayloadType =
    WidgetConfigSliceActionPayloadType<PlCapsuleConfigState>;
